export default __webpack_public_path__ + "static/media/SPRYT.57724043.png";